export const CASE_VIEW_PRIMARY_READING_CLASS = "text-[1.04rem] leading-7 sm:leading-8";
export const CASE_VIEW_SUPPORTING_READING_CLASS = "text-[1rem] leading-7";
export const CASE_VIEW_SUMMARY_READING_CLASS = "text-base leading-8 sm:text-[1.05rem]";
export const CASE_VIEW_SECTION_HEADING_CLASS = "mt-2 text-[1.7rem] font-bold text-white sm:text-2xl";
export const CASE_VIEW_CARD_TITLE_CLASS = "mt-2 text-lg font-semibold leading-tight text-white";
export const CASE_VIEW_PANEL_HEADING_CLASS = "mt-2 text-[1.55rem] font-bold leading-tight text-white sm:text-2xl";
export const CASE_VIEW_PAGE_TITLE_CLASS = "mt-3 text-[2rem] font-bold leading-tight sm:text-4xl";
export const CASE_VIEW_DISPLAY_TITLE_CLASS = "text-[2.15rem] font-black leading-[0.98] sm:text-5xl lg:text-6xl";
export const CASE_VIEW_HERO_READING_CLASS = "text-[1.05rem] leading-8 sm:text-[1.14rem] sm:leading-9 lg:text-[1.2rem]";
export const CASE_VIEW_METRIC_VALUE_CLASS = "mt-2 text-base font-semibold text-white sm:text-lg";

export const MARKETING_HERO_TITLE_CLASS =
  "text-[2.8rem] font-semibold leading-[0.96] sm:text-5xl lg:text-7xl xl:text-[6.25rem]";
export const MARKETING_SECTION_TITLE_CLASS =
  "mt-5 text-[2.1rem] font-semibold leading-[1.04] sm:text-5xl lg:text-6xl";
export const MARKETING_BODY_READING_CLASS =
  "text-[1.05rem] leading-8 sm:text-[1.18rem] sm:leading-9 lg:text-[1.3rem] lg:leading-10";
export const MARKETING_CARD_TITLE_CLASS = "mt-4 text-[1.4rem] font-semibold leading-tight sm:text-2xl";
export const MARKETING_CARD_BODY_CLASS = "mt-4 text-[1rem] leading-8 sm:text-lg sm:leading-9";
export const MARKETING_CTA_TEXT_CLASS = "text-lg font-semibold sm:text-xl";
